var React = require('react');

function Home (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"d":"M16 0L0 12.63l2.023 2.481 1.2-.963v14.296h11.166v-9.481h3.222v9.481h11.166V14.148l1.2.963L32 12.63 16 0zm9.593 25.296h-4.797v-9.481h-9.63v9.481H6.407V11.63L16 4.074l9.593 7.556v13.666z","fill":"#101010"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("path",{"fill":"#fff","d":"M0 0h32v28.444H0z"})))]);
}

Home.defaultProps = {"fill":"none","viewBox":"0 0 32 29"};

module.exports = Home;

Home.default = Home;
